module.exports = __webpack_public_path__ + "media/fonts/ufonts.com_gotham-light-9249716e.ttf";